import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {map} from 'rxjs/operators';

import {AccountService} from './account.service';

export const UserRouteAccessService: CanActivateFn = (route: ActivatedRouteSnapshot,  state: RouterStateSnapshot) => {

  const accountService = inject(AccountService);
  const router = inject(Router);
  const force = route.data['force'] as boolean | true;
  return accountService.loadIdentity(force).pipe(
    map(account => {
      if (!account) {
        accountService.logout();
        return true;
      }

      const roles = route.data['roles'] as string[] | undefined;
      if (!roles || roles.length === 0) {
        return true;
      }

      const hasRole = accountService.hasAnyAuthority(roles)
      if (!hasRole) {
        router.navigate(['/home']);
        return false;
      }

      return true;
    }),
  );
};
